// extracted by mini-css-extract-plugin
export default {"rating":"QesCard_rating__Sv1+M","crowdRating":"QesCard_crowdRating__-SS78"};